export { default } from '@triptyk/ember-utils/services/current-transition';
